import apolloClient from "@/apollo/apollo";
import gql from "graphql-tag";

const state = {
    serviceTypes: [],
};

const getters = {
    getAllServiceTypes: (state) => state.serviceTypes,
};

const mutations = {
    setAllServiceTypes(state, serviceTypes) {
        state.serviceTypes = serviceTypes.slice();
    },
};

const actions = {
    async fetchAllServiceTypes({ commit }, status) {
        try {
            const response = await apolloClient.query({
                query: gql`
          query findAllServiceTypes($status: ServiceTypeStatusEnum) {
            findAllServiceTypes(status: $status) {
              id
              name
              status
              creationDate
            }
          }
        `,
                variables: { status },
                context: {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("accessToken"),
                    },
                },
                fetchPolicy: "network-only",
            });
            commit("setAllServiceTypes", response.data.findAllServiceTypes);
            return response.data.findAllServiceTypes;
        } catch (error) {
            console.error("Failed to fetch service types:", error);
            return [];
        }
    },

    async createServiceType({ dispatch }, serviceTypeInput) {
        try {
            const response = await apolloClient.mutate({
                mutation: gql`
          mutation createServiceType($serviceTypeInput: ServiceTypeInput!) {
            createServiceType(serviceTypeInput: $serviceTypeInput) {
              id
              name
            }
          }
        `,
                variables: { serviceTypeInput },
                context: {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("accessToken"),
                    },
                },
            });
            return response.data.createServiceType;
        } catch (error) {
            console.error("Failed to create service type:", error);
            return null;
        }
    },

    async updateServiceType({ dispatch }, { id, serviceTypeInput }) {
        try {
            const response = await apolloClient.mutate({
                mutation: gql`
          mutation updateServiceType($id: Int!, $serviceTypeInput: ServiceTypeInput!) {
            updateServiceType(id: $id, serviceTypeInput: $serviceTypeInput) {
              id
              name
            }
          }
        `,
                variables: { id: +id, serviceTypeInput },
                context: {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("accessToken"),
                    },
                },
            });
            return response.data.updateServiceType;
        } catch (error) {
            console.error("Failed to update service type:", error);
            return null;
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
